import { useState } from 'react'
import { format, parse } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { Input } from './input'
import { Popover } from './popover'
import { Calendar } from './calendar'

interface DatePickerProps {
  id?: string
  value: string // yyyy-MM-dd
  onChange: (value: string) => void
  required?: boolean
}

/** 日期选择器：点击 Input 弹出日历面板，同时保留手动输入 */
export function DatePicker({ id, value, onChange, required }: DatePickerProps) {
  const { i18n } = useTranslation()
  const [open, setOpen] = useState(false)

  const date = (() => {
    const parsed = parse(value, 'yyyy-MM-dd', new Date())
    return Number.isNaN(parsed.getTime()) ? new Date() : parsed
  })()

  const handleSelect = (d: Date) => {
    onChange(format(d, 'yyyy-MM-dd'))
    setOpen(false)
  }

  return (
    <div className="relative">
      <Input
        id={id}
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onClick={() => setOpen(true)}
        onFocus={() => setOpen(true)}
        required={required}
      />
      <Popover open={open} onClose={() => setOpen(false)} align="right">
        <Calendar value={date} onChange={handleSelect} locale={i18n.language} />
      </Popover>
    </div>
  )
}
